import { clsx, type ClassValue } from "clsx";

/**
 * Join class names, dropping the falsy ones.
 *
 * Under the utility layer this had to arbitrate between conflicting atomic
 * classes, because `bt-u-mb-3` and `bt-u-mb-0` had identical specificity and the
 * winner fell to the source order of utilities.css rather than to the caller
 * (docs/adr/0013). Semantic classes removed that problem: a component's base
 * class and its modifiers live in the same sheet, in the intended order, so
 * `.bt-card__title--flush` beats `.bt-card__title` by ordinary cascade
 * (docs/adr/0016). What is left is clsx.
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
